import Client from 'api/Client'
import { authTokenSelector } from './selectors'

export default (state) => {
  const authToken = authTokenSelector(state)
  return new Client(authToken)
}
